import styled from 'styled-components';

export const CourtFieldWrapper = styled.div`
  position: relative;
`;

export const CourtSuggestionsList = styled.div`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  width: calc(100% - ${({ theme }) => theme.spacing[6]});
  max-height: 200px;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadows.md};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const CourtSuggestionItem = styled.div`
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  transition: background-color ${({ theme }) => theme.transitions.fast};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary50};
  }
`;
